





























import { Component, Vue, Prop } from 'vue-property-decorator';
import AppCardLayout from '../CardLayout';
import AppCardMainLayout from '../CardMainLayout';
import AppCardSliderLayout from '../CardSliderLayout';
import AppCardSidebarLayout from '../CardSidebarLayout';

@Component({
  components: {
    AppCardLayout,
    AppCardMainLayout,
    AppCardSliderLayout,
    AppCardSidebarLayout,
  },
})
export default class AppCardTotalLayout extends Vue {
  @Prop({ type: String, default: 'left' })
  readonly sidebarPosition: 'left' | 'right';
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/layouts/cardlayouts/CardTotalLayout/AppCardTotalLayout.vue